var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{ref:"myTextEditor",staticClass:"editor",attrs:{"value":_vm.content,"options":_vm.editorOption},on:{"change":_vm.onEditorChange,"blur":function($event){return _vm.onEditorBlur($event)},"focus":function($event){return _vm.onEditorFocus($event)},"ready":function($event){return _vm.onEditorReady($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }